<template>
   <div>
      <header
         style="z-index: 10"
         id="searchPage"
         :style="{ background: `url(${bgPage})` }"
         :class="{ 'no-background': !bgPage }"
         class="header-page-search bg-cover bg-center mb-0 mb-lg-4 position-relative"
      >
         <b-container class="calendar-home-wrap p-4 pl-md-3 pr-md-3">
            <b-row align-h="center" align-v="center">
               <!--Search block-->
               <b-col cols="12" lg="6" class="search-block mb-4 mb-lg-0">
                  <SearchBlock
                     title="Buscar bicicletas para alugar"
                     :col1="12"
                     :col2="12"
                     @click="onSearch"
                  />
               </b-col>

               <!-- Título resultado / sem resultado / buscando... -->
               <b-col
                  cols="12"
                  lg="6"
                  class="title-results-search pl-xs-0 pl-xl-5 text-center"
               >
                  <!-- Houve Resultados -->
                  <div v-if="this.bikes.length">
                     <h3>
                        Encontramos
                        <strong>{{
                           this.bikes.length && this.bikes.length > 1
                              ? this.bikes.length + " bicicletas"
                              : this.bikes.length + " bicicleta"
                        }}</strong>
                        para você pedalar em
                        <strong style="text-transform: capitalize">{{
                           locality
                        }}</strong>
                     </h3>
                  </div>

                  <!-- Buscando... -->
                  <div v-if="loading">
                     <h3>
                        <i class="el-icon-loading"></i> Buscando bicicletas em
                        {{ locality }}...
                     </h3>
                  </div>

                  <!-- Sem Resultados -->
                  <div v-if="!this.bikes.length && !loading && !options.new">
                     <h3 v-if="searchState">
                        Ops, não encontramos nenhuma bicicleta em
                        <strong>{{ locality }}</strong
                        >! Pesquise em uma cidade próxima ;)
                     </h3>

                     <h3
                        class="results-text-search text-white mt-0 mt-lg5 text-center text-lg-left font-weight-normal"
                        v-else
                     >
                        Ops, não encontramos nenhuma bicicleta para a sua busca.
                        Tente outra cidade!
                     </h3>
                  </div>

                  <!-- Nova Busca -->
                  <div v-if="!this.bikes.length && !loading && options.new">
                     <h3
                        class="results-text-search text-white mt-0 mt-lg5 text-center text-lg-left font-weight-normal"
                     >
                        Procure uma bicicleta para alugar agora mesmo.
                     </h3>
                  </div>

                  <strong v-if="bgPage"></strong>
                  <p class="lead" v-if="false">
                     <slot></slot>
                  </p>
               </b-col>
            </b-row>
         </b-container>
      </header>

      <b-container class="mb-5 no-search-results-wrap">
         <transition name="slide" mode="in-out">
            <b-container v-if="loading" class="mt-3 mt-md-0">
               <!-- Skeleton -->
               <b-row>
                  <b-col
                     cols="12"
                     sm="6"
                     lg="4"
                     xl="4"
                     class="mb-4 p-0 p-md-4"
                     v-for="n in 6"
                     :key="n"
                  >
                     <b-card no-body img-top>
                        <b-skeleton-img card-img="top" aspect="2:1">{{
                           n
                        }}</b-skeleton-img>
                        <b-card-body>
                           <b-skeleton
                              animation="fade"
                              width="85%"
                           ></b-skeleton>
                           <b-skeleton
                              animation="fade"
                              width="55%"
                           ></b-skeleton>
                           <b-skeleton
                              animation="fade"
                              width="70%"
                           ></b-skeleton>
                        </b-card-body>
                     </b-card>
                  </b-col>
               </b-row>
            </b-container>
         </transition>

         <transition name="fade" mode="out-in">
            <!-- Card Bicicleta -->
            <b-container class="mt-3 mt-md-0">
               <!-- Card Bicicleta -->
               <b-row
                  v-if="!loading && bikes.length"
                  class="position-relative"
                  style="z-index: 1"
               >
                  <!-- eslint-disable -->
                  <b-col
                     v-if="bike.user"
                     md="6"
                     lg="4"
                     xl="4"
                     class="mb-4 p-0 p-md-4"
                     v-for="(bike, index) in bikes"
                     :key="index"
                  >
                     <CardBike
                        v-if="bike._id"
                        :loading="loading"
                        :bike="bike"
                     />
                  </b-col>
               </b-row>
            </b-container>
         </transition>

         <el-image
            v-if="this.bikes.length &lt; 1 && !this.options.new"
            class="no-search-results-img"
            :src="noResultsImg"
         >
         </el-image>
         <el-image
            v-if="this.options.new"
            class="no-search-results-img"
            :src="newSearchImg"
         >
         </el-image>
      </b-container>
   </div>
</template>

<script>
import bgPage from "@/assets/img/ajuda-pedale.jpg";
import SiteService from "@/services/site.service";
import noResultsImg from "@/assets/img/no-results-search.svg";
import newSearchImg from "@/assets/img/new-seash.svg";
import SearchBlock from "@/components/SearchBlock";
import CardBike from "@/components/CardBike";
import { BSkeleton, BSkeletonImg, BCard, BCardBody } from "bootstrap-vue";

export default {
   name: "search",
   components: {
      SearchBlock,
      CardBike,
      BSkeleton,
      BSkeletonImg,
      BCard,
      BCardBody,
   },
   directives: {
      "b-skeleton": BSkeleton,
      "b-skeleton-img": BSkeletonImg,
      "b-card": BCard,
      "b-card-body": BCardBody,
   },
   data() {
      return {
         bgPage,
         bikes: "",
         noResultsImg,
         newSearchImg,
         loading: true,
         options: {
            new: false,
         },
         locality: "",
      };
   },

   mounted() {
      const { city, dates } = this.$route.params;
      const { latitude, longitude, locality } = this.currentPlace.place;
      const queryString = this.currentPlace.queryString;

      this.options.new = false;
      this.loading = true;

      const query = {
         city: "",
         locality: "",
      };

      // Caso tenha localidade a partir da api do google, inputado no campo busca
      if (locality) query.locality = locality.split(",")[0];

      // Caso tenha uma cidade enviada a partir da url no parâmetro city. Ex: /bicicletas/Curitiba
      if (city) query.city = city.split("-").join(" ");

      // Tendo localidade, então busca bikes em um raio x a partir das coordenadas enviadas.
      if (query.locality)
         this.searchBikes(query.locality, `${longitude}, ${latitude}`, dates);

      // Não tendo localidade mas tendo a cidade via parâmetro url, então busca bikes na cidade digitada.
      if (!query.locality && query.city)
         this.searchBikes(query.city, undefined, dates);

      if (!city && !locality && queryString) {
         this.searchBikes(queryString);
      }

      if (!city && !locality && !queryString) {
         this.options.new = true;
         this.loading = false;
      }
   },
   methods: {
      searchBikes(city, coordinates, dates) {
         this.locality = city;
         this.loading = true;
         this.bikes = [];
         this.options.new = false;
         setTimeout(() => {
            SiteService.searchBikes(city, coordinates, dates).then(
               (response) => {
                  this.bikes = response.data.data;
                  this.loading = false;
               },
               (err) => {
                  this.$message.error(err.response.data.message);
                  this.loading = false;
                  this.$loading().close();
               }
            );
         }, 500);
      },

      async onSearch(query) {
         this.searchBikes(query.locality, query.coordinates);
      },
   },
   computed: {
      searchState() {
         return this.$store.state.search.query;
      },
      currentPlace() {
         return this.$store.state.place;
      },
   },
   watch: {
      $route: {
         handler: function (page) {
            if (page.params.city)
               this.locality = page.params.city.replaceAll("-", " ");
            switch (page.params.options) {
               case "new":
                  this.options.new = true;
                  this.loading = false;
                  break;
            }
         },
         deep: true,
         immediate: true,
      },
   },
};
</script>

<style lang="scss">
.header-page-search {
   @media only screen and (min-width: 996px) {
      padding: 40px 0;
   }
}
</style>
